var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-loadmore",class:{'weui-loadmore_line':_vm.line,'weui-loadmore_dot':_vm.dot}},[_vm._t("prefix"),_c('span',{staticClass:"weui-loadmore__tips"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }